<!--
 * @Description: newtable组件
 * @Author: fal
 * @FilePath: \xhlz_pc\src\project\components\newtable.vue
 * @LastEditTime: 2025-09-12 13:57:19
-->
<template>
  <div style="overflow: hidden">
    <el-table
      :data="list"
      lazy
      style="width: 100%"
      :header-cell-style="
        ({ column, columnIndex }) => {
          let style = {
            color: '#6B6B6B',
            fontWeight: 'normal',
            //border: 'none',
            background: 'rgba(11, 47, 89, 0.06)',
          };

          // First column
          if (columnIndex === 0) {
            style.borderRadius = '4px 0 0 4px';
          }

          // Last column
          if (columnIndex === columns.length - 1) {
            style.borderRadius = '0 4px 4px 0';
          }

          return style;
        }
      "
      :cell-style="{
        borderBottom: '1px solid #EBEEF5',
        background: 'transparent',
        //borderRight: 'none',
      }"
      :height="head_height"
      :max-height="maxHeight"
      border
      row-key="id"
      :load="loadTreeData"
      ref="table"
      :row-style="{ fontSize: '13px' }"
      @selection-change="handleSelectionChange"
      @row-click="rowclick"
      @select-all="selectAll"
      :tree-props="{ children: 'sons', hasChildren: 'hasChildren' }"
      :row-class-name="tableRowClassName"
      v-loading="loading"
      element-loading-text="加载中"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="custom-border-table"
    >
      <!--数据源api/admin.project.item/material_detail_list-->
      <template v-for="(column, index) in columns">
        <el-table-column type="selection" v-if="column.type === 'selection'" :key="column.index" :selectable="handleSelectable"></el-table-column>
        <el-table-column
          v-if="checkList.includes(column.label) && column.type !== 'selection'"
          :header-align="column.align ?? 'left'"
          :type="column.type"
          :sortable="column.hasSort"
          :key="column.label"
          :prop="column.prop"
          :label="column.label"
          :fixed="column.fixed"
          :align="column.align ?? 'left'"
          :show-overflow-tooltip="column.showOverflowTooltip ?? true"
          :width="column.width"
        >
          <template slot="header">
            <span v-if="index === columns.length - 1">
              <span>{{ column.label }}</span>
              <el-dropdown ref="dropdown" v-if="columns.length > 0 && mei" class="right-icon" trigger="click" @click.stop>
                <el-tooltip class="item" effect="dark" content="选择列" placement="top">
                  <div class="el-dropdown-link" style="cursor: pointer" @click="handleShow">
                    <i class="el-icon-s-grid" style="color: #1b70ff; font-size: 20px; line-height: 39px"></i>
                  </div>
                </el-tooltip>
                <el-dropdown-menu slot="dropdown">
                  <el-scrollbar style="height: 200px">
                    <div style="min-width: 80px; padding-left: 14px; padding-right: 14px">
                      <el-checkbox-group v-model="checkList" @change="getChecked">
                        <el-checkbox
                          style="display: block"
                          class="mb-5"
                          :label="item.label"
                          :value="item.prop"
                          v-for="(item, index) in columns.filter((item) => item.type != 'selection' && item.label != '操作')"
                          :key="index"
                        >
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </el-scrollbar>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
            <span v-else>{{ column.label }}</span>
          </template>
          <template slot-scope="scope">
            <template v-if="column.render">
              <ex-slot :render="column.render" :row="scope.row" :index="scope.$index" :column="column" />
            </template>
            <template v-else>
              <template v-if="column.prop == 'needslot'">
                <slot name="extra" :row="scope.row" :scope="scope"> </slot>
              </template>
              <template v-if="column.edit == true && edit">
                <el-input clearable v-model="scope.row[column.prop]" placeholder=""></el-input>
              </template>
              <template v-if="column.type == 'img'">
                <el-image style="width: 80px; height: 80px" :src="`${$url}${scope.row[column.prop]}`" :preview-src-list="[`${$url}${scope.row[column.prop]}`]" fit="contain" />
              </template>
              <template v-if="column.type == 'image'">
                <el-image style="width: 80px; height: 80px" :src="scope.row[column.prop]" :preview-src-list="[scope.row[column.prop]]" fit="contain" />
              </template>
              <template v-if="!column.edit && edit">
                {{ scope.row[column.prop] }}
              </template>
              <template v-if="column.prop === 'index'">
                <span v-text="getIndex(scope.$index)"></span>
              </template>
              <template v-if="column.prop === 'index2'">
                <span v-text="getIndex2(scope.$index, scope.row)"></span>
              </template>
              <template v-if="column.label == '操作'">
                <slot name="oper" :row="scope.row" :scope="scope"> </slot>
              </template>
              <template v-if="column.slot">
                <slot :name="column.slotName" :row="scope.row" :scope="scope"> </slot>
              </template>
              <template v-else-if="column.type != 'selection' && !edit && column.type != 'img' && column.type != 'image'">
                <span v-if="column.prop == 'tax_price' && column.light" class="light" @click="jump(scope.row, column.prop, scope, column)">
                  {{ formatCurrency(scope.row[column.prop]) }}
                </span>
                <span v-else-if="column.light" class="light" @click="jump(scope.row, column.prop, scope, column)">
                  {{ scope.row[column.prop] }}
                </span>
                <span v-else> {{ scope.row[column.prop] }}</span>
              </template>
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      class="mt-20"
      v-if="!nopage"
      background
      style="text-align: right"
      :total="total"
      :page-size.sync="pageSize1"
      :current-page.sync="page1"
      :page-sizes="pageSizes"
      layout="total, sizes, prev, pager, next"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      v-bind="$attrs"
    >
    </el-pagination>
  </div>
</template>

<script>
var exSlot = {
  functional: true,
  props: {
    row: Object,
    render: Function,
    index: Number,
    column: {
      type: Object,
      default: null,
    },
  },
  render: (h, data) => {
    const params = {
      row: data.props.row,
      index: data.props.index,
    };
    if (data.props.column) params.column = data.props.column;

    return data.props.render(h, params);
  },
};
import { formatCurrency } from '@/project/utils/index';
export default {
  name: 'newtable',
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    mei: {
      type: Boolean,
      default: true,
    },
    total: {
      type: Number,
      default: 0,
    },
    ex: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    nopage: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
    totalList: {
      type: Array,
      default: () => [],
    },
    clickId: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    currentRow: {
      type: Boolean,
      default: false,
    },
    head_height: {
      type: String,
      default: null,
    },
    maxHeight: {
      type: String,
      default: '600px',
    },
    highlightRow: {
      type: Object,
      default: () => ({}),
    },
    // 默认展示列
    showColumns: {
      type: Array,
      default: () => [],
    },
    // 表格预警 is_warn == 1
    warnRow: {
      type: Boolean,
      default: false,
    },
    defaultPageSize: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30],
    },
    showResign: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    exSlot,
  },
  watch: {
    page(val) {
      this.page1 = val;

      // 根据存储的 ID 恢复选中状态
      this.selection = this.list.filter((item) => this.selectedIds.includes(item.id));
      // this.$forceUpdate()
    },
    pageSize(val) {
      this.pageSize1 = val;
    },
    nopage(val) {
      if (val) {
        this.page1 = 1;
        this.pageSize1 = this.defaultPageSize;
      }
    },
    ex(newV) {
      this.$refs.table.clearSelection();
    },
    columns() {
      let num = document.getElementById('app').clientHeight;

      this.checkList = this.showColumns.length ? this.showColumns : this.columns.map((item) => item.label);
      if (this.isNow) {
        this.checkList = this.checkList.filter((currentValue, index, arr, thisValue) => {
          return currentValue != '操作';
        });
      }
    },
  },
  data() {
    return {
      checkList: [],
      selectedIds: [],
      page1: 1,
      pageSize1: this.defaultPageSize,
      show: false,
      selection: [],
      btnType: 0,
      isNow: false,
      currentRowdata: null,
      checkedKeys: false,
    };
  },
  created() {
    this.btnType = this.$route.query.queryType;
    let only = sessionStorage.getItem('operation');
    if (only == 'only') {
      this.isNow = true;
    } else {
      this.isNow = false;
    }
  },
  mounted() {
    this.page1 = this.page == 10 ? this.page1 : this.page;
    // this.pageSize1 = this.pageSize == 10 ? this.pageSize1 : this.defaultPageSize;
    let num = document.getElementById('app').clientHeight;
    this.checkList = this.showColumns.length ? this.showColumns : this.columns.map((item) => item.label);
    if (this.isNow) {
      this.checkList = this.checkList.filter((currentValue, index, arr, thisValue) => {
        return currentValue != '操作';
      });
    }

    setTimeout(() => {
      this.show = true;
    }, 5000);
  },
  methods: {
    // 格式化数据，显示千位分隔符
    formatCurrency(value) {
      return formatCurrency(value);
    },
    // 根据当前行和警告行设置表格行的样式
    tableRowClassName({ row, rowIndex }) {
      // 如果当前行存在且当前行数据等于行数据，则返回selected-row样式
      if (this.currentRow && this.currentRowdata == row) {
        return 'selected-row';
      }
      // 如果警告行存在且行数据中的is_warn等于1，则返回warning-row样式
      if (this.warnRow && row.is_warn == 1) {
        return 'warning-row';
      }
      if (row.showSummary == true) {
        return 'summary-row';
      }
      if (row.showWarn == true) {
        return 'warning-row';
      }
      if (row.showSuccess == true) {
        return 'success-row';
      }
      if (this.showResign && row.resign_time) {
        return 'resign-row';
      }
      // 否则返回空样式
      return '';
    },
    // 加载树形数据
    loadTreeData(tree, treeNode, resolve) {
      // 设置延时200毫秒后执行resolve函数，加载树形数据
      setTimeout(() => {
        resolve(tree.sons);
      }, 200);
    },
    // 获取选中项
    getChecked() {
      this.$forceUpdate();
    },
    // 获取页面高度
    getClientHeight() {
      let clientHeight = 0;
      // 如果document.body.clientHeight和document.documentElement.clientHeight都存在
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        // 取两者中较小的值
        const clientHeight = document.body.clientHeight < document.documentElement.clientHeight ? document.body.clientHeight : document.documentElement.clientHeight;
      } else {
        // 否则取两者中较大的值
        const clientHeight = document.body.clientHeight > document.documentElement.clientHeight ? document.body.clientHeight : document.documentElement.clientHeight;
      }
      return clientHeight;
    },
    // 处理check选择变化
    handleSelectionChange(e) {
      console.log('-------触发handleSelectionChange', e);

      this.selection = e;
      // 触发自定义事件exdata，传递选中的id
      this.$emit(
        'exdata',
        e.map((item) => item.id)
      );
      // 触发自定义事件exdata2，传递选中的数据
      this.$emit('exdata2', e);
      // 触发自定义事件exdata3，传递选中的project_id
      this.$emit(
        'exdata3',
        e.map((item) => item.project_id)
      );
    },
    // 跳转
    jump(row, prop, all, column) {
      row.prop = prop;
      row.index = all.$index;
      // 触发自定义事件clicked，传递row
      this.$emit('clicked', row);
    },
    // 获取索引
    getIndex(index) {
      // 计算当前页的索引
      return (this.page - 1) * this.pageSize1 + index + 1;
    },
    // 获取索引2
    getIndex2(index, row) {
      return '';
    },
    // 处理点击事件
    handleClick(index, row, label) {
      // 触发自定义事件handleoperationClick，传递index、row和label
      this.$emit('handleoperationClick', { index, row, label });
    },
    // 处理分页大小变化
    handleSizeChange(limit) {
      console.log('-------handleSizeChange');
      // 更新分页大小
      this.pageSize1 = limit;
      setTimeout(() => {
        // 触发自定义事件pagination，传递当前页和分页大小
        this.$emit('pagination', { page: this.page1, pageSize: limit });
      }, 90);
    },
    // 监听当前是第几页（page）
    handleCurrentChange(page) {
      console.log('-------handleCurrentChange');
      this.page1 = page;

      this.$emit('pagination', { page: page, pageSize: this.pageSize1 });
    },
    //点击某一行触发时间
    rowclick(row, column, event) {
      this.currentRowdata = row;
      this.$emit('rowclick', row);
    },
    // 全选或全不选，要手动处理子项check也跟随变化
    selectAll() {
      this.checkedKeys = !this.checkedKeys;
      this.splite(this.list, this.checkedKeys);
    },
    // 递归遍历数据，根据flag来选择或取消选择
    splite(data, flag) {
      data.forEach((row) => {
        // 调用toggleRowSelection方法，传入row和flag
        this.$refs.table.toggleRowSelection(row, flag);
        // 如果row有sons属性，则递归调用splite方法
        if (row.sons != undefined) {
          this.splite(row.sons, flag);
        }
      });
    },
    // 判断行是否可选
    handleSelectable(row, index) {
      // 如果row有noSelection属性，则返回false禁止勾选
      if (row.noSelection) {
        return false;
      }
      return true;
    },
    // 手动触发展示列下拉框
    handleShow() {
      this.$refs.dropdown[0]?.show();
    },
  },
};
</script>

<style lang="less">
.btn {
  position: relative;

  input {
    position: absolute;
    left: 0;
    opacity: 0;
    width: 90px;
  }
}

.btn i {
  font-size: 15px;
}

/deep/ .el-table__empty-block {
  text-align: center;
}

.choose {
  width: 85px;
  height: 30px;
  background: #5da0f9;
  border-radius: 3px 3px 3px 3px;
  color: white;
  line-height: 30px;
  font-size: 13px;
  text-align: center !important;
  cursor: pointer;
}

.empty {
  .no-data-1 {
    position: absolute;
    bottom: 18px;
    left: 140px;
    font-size: 19px;
  }

  .no-data-2 {
    position: absolute;
    bottom: 3px;
    left: 87px;
    font-size: 12px;
  }
}

.el-table .warning-row {
  background: #fff1ef;
}

.el-table .summary-row {
  background: #fff8e7;
}

.el-table .success-row {
  background: #ebfaf6;
}

.el-table .resign-row {
  color: #999999;
}

// .el-table .warning-row2 {
//   background: #e5c1c1;
// }
.selected-row {
  background-color: rgba(230, 239, 255, 0.8) !important; /* 设置点击后的行颜色 */
}
.custom-border-table {
  // border: none !important;

  // 移除表头的下边框
  /deep/ .el-table__header-wrapper th.el-table__cell {
    // border-bottom: none !important;
  }

  // 移除最后一行的下边框
  /deep/ .el-table__body tr:last-child td {
    //border-bottom: none !important;
  }

  /deep/ .el-table__body-wrapper {
    //border-bottom: none !important;
  }

  // 自定义整个表头样式
  /deep/ .el-table__header-wrapper {
    border-radius: 4px;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #0b2f59;
      opacity: 0.06;
      z-index: 1;
    }

    .el-table__header {
      z-index: 2;
    }
  }

  // 确保表头文字清晰可见
  /deep/ .el-table__header-wrapper th.el-table__cell {
    background: transparent;
    color: #666; // 或者您想要的其他颜色
  }
}

// 全局样式
.el-table {
  //border: none !important;

  // &::before,
  // &::after {
  //   height: 0 !important;
  //   display: none !important;
  // }

  .el-table__cell {
    height: 39px;
    padding: 0;
    // border-right: none !important;
  }

  // .el-table__fixed-right-patch {
  //   // background-color: transparent !important;
  // }

  // .el-table__fixed-footer-wrapper::after,
  // .el-table__fixed-header-wrapper::after {
  //   display: none !important;
  // }

  // .el-table__fixed-right,
  // .el-table__fixed {
  //   box-shadow: none !important;
  // }
  // 确保表格容器没有边框
  // .el-table__body-wrapper,
  // .el-table__footer-wrapper {
  //   // border-bottom: none !important;
  // }
}

// 移除可能的表格底部边框
// .el-table::after {
//   display: none !important;
// }

// 移除固定列可能造成的边框
// .el-table__fixed-right::before,
// .el-table__fixed::before,
// .el-table__fixed-right::after,
// .el-table__fixed::after {
//   display: none !important;
// }

.el-table th.el-table__cell > .cell {
  height: 39px;
  line-height: 39px;
  padding: 0 10px;
  position: relative;
  // padding-right: 0 !important;
  //text-align: left;
}

.right-icon {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9;
  display: inline-block;
  text-align: center;
  height: 39px;
  width: 39px;
  border-radius: 4px;
  background: rgba(230, 239, 255, 1);
}
</style>
